<template lang="pug">
	section.detail-features
		ul.deatil-featureGroup(v-for="feature in features")
			li.detail-featureTitle(:style="styles.primary.color") {{ feature.Title }}
			transition-group.detail-featureList(
				name="detail-featureList",
				tag="ul")
				li.detail-featureItem(
					v-for="item in feature.Items",
					:key="item") {{ item }}
</template>


<script>
import Theme from "@/listing-app/mixins/Theme";
export default {
  name: "Features",
  mixins: [Theme],
  props: ["features"]
};
</script>


<style lang="scss" scoped>
.detail-features {
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-top: 40px;
  padding: 40px;
  border-top: 1px solid $gray;
  background: $offWhite;
  @media (min-width: 991px) {
    flex-direction: row;
  }
}

.deatil-featureGroup {
  display: flex;
  flex-direction: column;
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  list-style: none;
  @media (min-width: 991px) {
    @include justify;
    flex: 1 1 0;
		margin-left: 40px;
		margin-bottom: 0;
    padding-right: 40px;
    border-right: 1px solid $gray;
    &:last-child {
      border-right: none;
    }
  }
}

.detail-featureTitle {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  margin: 0 0 5px;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.detail-featureList {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
	font-family: HelveticaNeueW02-57Cn;
	&-enter,
	&-leave-to  {
		opacity: 0;
		transform: translateY(-30px);
	}
	&-leave-active {
		position: absolute;
	}
}

.detail-featureItem {
  transition: all 0.5s ease;
  margin-bottom: 8px;
	font-size: 1.125rem;
  line-height: 1.35;
}
</style>
